import React from 'react';

import PropTypes from 'prop-types';

import * as Style from './style';

const Flex = ({
	children,
	width,
	height,
	align,
	justify,
	direction,
	wrap,
	margin,
	padding,
	className,
	role,
	border,
	borderRadius,
	flex,
	...props
}) => (
	<Style.Container
		role={role}
		width={width}
		height={height}
		align={align}
		justify={justify}
		direction={direction}
		wrap={wrap}
		margin={margin}
		padding={padding}
		border={border}
		borderRadius={borderRadius}
		className={className}
		flex={flex}
		{...props}
	>
		{children}
	</Style.Container>
);

Flex.defaultProps = {
	width: '100%',
	height: 'auto',
	align: 'flex-start',
	justify: 'flex-start',
	direction: 'row',
	wrap: 'no-wrap',
	margin: 'auto',
	padding: 'auto',
	className: '',
	role: 'gridcell',
	border: '',
	borderRadius: '',
	flex: '',
};

Flex.propTypes = {
	border: PropTypes.string,
	children: PropTypes.isRequired,
	width: PropTypes.string,
	height: PropTypes.string,
	align: PropTypes.string,
	justify: PropTypes.string,
	direction: PropTypes.string,
	wrap: PropTypes.string,
	margin: PropTypes.string,
	padding: PropTypes.string,
	className: PropTypes.string,
	role: PropTypes.string,
	borderRadius: PropTypes.string,
	flex: PropTypes.string,
};

export default Flex;
